<div class="card text-white bg-primary my-3">
  <div class="card-header">CLIENT CODE</div>
  <div class="card-body text-center">
    <p class="card-text">Add new Client Code</p>
    <input 
      type="text" 
      class="form-control text-center mx-auto w-25" 
      [class.is-invalid]="hasError"
      [readonly]="readonlyClientCode" 
      [value]="customer?.code || ''" 
      (input)="onCodeChange($event.target)" 
      placeholder="- - -" 
      maxlength="4"
      [disabled]="readonlyClientCode"
    />
    @if (hasError) {
      <div class="invalid-feedback d-block">
        Client Code is required
      </div>
    }
  </div> 
</div>